export function getStageSpecificValue(stage: string, values: { [key: string]: string }) {
  for (const [key, value] of Object.entries(values)) {
    //To be safe, only treat a stage as regex if it begins with ^ and ends with $
    const keyIsRegexp = key.startsWith("^") && key.endsWith("$");
    if (keyIsRegexp && new RegExp(key).test(stage)) {
      return value;
    } else if (stage === key) {
      return value;
    }
  }
  return values.default;
}
